import {
  DETAIL_SET,
  DETAIL_SET_SUCCESS,
  DETAIL_SET_ERROR,
  DETAIL_GET_COUNTRY,
  DETAIL_GET_COUNTRY_SUCCESSFULL,
  DETAIL_GET_COUNTRY_FAILED,
  DETAIL_GET_STATE,
  DETAIL_GET_STATE_SUCCESSFULL,
  DETAIL_GET_STATE_FAILED,
  DETAIL_GET_IP_LOCATION,
  DETAIL_GET_IP_LOCATION_SUCCESSFULL,
  DETAIL_GET_IP_LOCATION_FAILED,

  GET_COUNTRY_BY_IP,
  GET_COUNTRY_BY_IP_SUCCESSFULL,
  GET_COUNTRY_AND_STATE,
  GET_COUNTRY_AND_STATE_SUCCESS,
  GET_COUNTRY_AND_STATE_FAILED,
  CAREER_PREVIEW_PROFILE_UPDATE,
  CAREER_PREVIEW_PROFILE_UPDATE_SUCCESS,
  CAREER_PREVIEW_PROFILE_UPDATE_FAILURE,
  SEND_TO_DEVELOPER,
  SEND_TO_DEVELOPER_SUCCESS,
  SEND_TO_DEVELOPER_FAILURE,

} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  setDetailError: null,
  setCountryData: null,
  setCountryDataError: null,
  setStatesData: null,
  setStatesDataError: null,
  setIplocation: null,
  setIplocationError: null,
  loading: false,
  countryAndState: null,
  countryAndStateFailed: null,
  previewError: null,
  previewData: null,
  developerData: null,
  developerError: null,
}

const detailSet = (state = initialState, action) => {
  switch (action.type) {
    case DETAIL_SET:
      state = {
        ...state,
        detailSetSuccess: null,
        setDetailError: null,
        loading: true
      }
      break
    case DETAIL_SET_SUCCESS:
      state = {
        ...state,
        detailSetSuccess: action.payload,
        loading: false
      }
      break
    case DETAIL_SET_ERROR:
      state = { ...state, setDetailError: action.payload, loading: false }
      break

    case DETAIL_GET_COUNTRY:
      state = {
        ...state,
        setCountryData: null,
        setCountryDataError: null,

      }
      break
    case DETAIL_GET_COUNTRY_SUCCESSFULL:
      state = {
        ...state,
        setCountryData: action.payload,
        loading: false
      }
      break
    case DETAIL_GET_COUNTRY_FAILED:
      state = {
        ...state,
        setCountryDataError: action.payload,
        loading: false
      }
      break

    case DETAIL_GET_STATE:
      state = {
        ...state,
        setStatesData: null,
        setStatesDataError: null,

      }
      break
    case DETAIL_GET_STATE_SUCCESSFULL:
      state = {
        ...state,
        setStatesData: action.payload,
        loading: false
      }
      break
    case DETAIL_GET_STATE_FAILED:
      state = {
        ...state,
        setStatesDataError: action.payload,
        loading: false
      }
      break

    case DETAIL_GET_IP_LOCATION:
      state = {
        ...state,
        setIplocation: null,
        setIplocationError: null,
        loading: true
      }
      break
    case DETAIL_GET_IP_LOCATION_SUCCESSFULL:
      state = {
        ...state,
        setIplocation: action.payload,
        loading: false
      }
      break
    case DETAIL_GET_IP_LOCATION_FAILED:
      state = {
        ...state,
        setIplocationError: action.payload,
        loading: false
      }
      break
    case GET_COUNTRY_BY_IP:
      state = {
        ...state,
        countryCode: null,
        loading: true
      }
      break
    case GET_COUNTRY_BY_IP_SUCCESSFULL:
      state = {
        ...state,
        countryCode: action.payload,
        loading: false,
      }
      break
    case GET_COUNTRY_AND_STATE:
      state = {
        ...state,
        loading: false,
        countryAndState: null,
        countryAndStateFailed: null,
      }
      break
    case GET_COUNTRY_AND_STATE_SUCCESS:
      state = {
        ...state,
        countryAndState: action.payload,
        countryAndStateFailed: null,

      }

      break
    case GET_COUNTRY_AND_STATE_FAILED:
      state = {
        ...state,
        countryAndState: null,
        countryAndStateFailed: action.payload,

      }

      break

    case CAREER_PREVIEW_PROFILE_UPDATE:
      state = {
        ...state,
        loading: true,
        previewData: null,
        previewError: null

      }

      break

    case CAREER_PREVIEW_PROFILE_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        previewData: action.payload,
      }

      break
    case CAREER_PREVIEW_PROFILE_UPDATE_FAILURE:
      state = {
        ...state,
        loading: false,
        previewError: action.payload,
      }
      break
      case SEND_TO_DEVELOPER:
        state = {
          ...state,
          developerData: null,
          developerError: null,
        }
        break
        case SEND_TO_DEVELOPER_SUCCESS:
          state = {
            ...state,
            developerData: action.payload,
            developerError: null,
          }
          break 
          case SEND_TO_DEVELOPER_FAILURE:
          state = {
            ...state,
            developerData: null,
            developerError: action.payload,
          }
          break 

    default:
      state = { ...state }
      break
  }
  return state
}

export default detailSet
